<div class="rs-section-under-header rs-neg rs-pos-rel">
  <div
    class="rs-bgi-cover-ct rs-pos-tl rs-maxw rs-mh-s30 rs-mh-m42 rs-mh-l48"
  ></div>
  <div>
    <div class="rs-pos-rel">
      <section class="rs-overlapped rs-mh-s29 rs-mh-m32 rs-mh-l38">
        <mprd-back-link></mprd-back-link>
        <div class="rs-fe2"></div>
        <div class="row">
          <div class="small-7 medium-6 large-5 columns">
            <h1
              class="rs-tit1-sp rs-has-subtit"
              data-cy="optionDetailsOptionName"
            >
              {{ optionName }}
            </h1>
            <h2 class="rs-subtit">{{ optionDescriptionName }}</h2>
            <div
              *ngIf="option?.trialOption"
              class="rs-patch-promo rs-patch-corner2"
            >
              <ng-container *ngIf="!option?.tryAndBuyFreeFor3Months">
                {{ "tv.active.options.try.and.buy" | translate }}
              </ng-container>
              <ng-container *ngIf="option?.tryAndBuyFreeFor3Months">
                {{ "tv.active.options.try.and.buy.3months" | translate }}
              </ng-container>
            </div>
            <p *ngIf="isActiveTrialOption" class="rs-padding-bottom1">
              <ng-container
                *ngIf="option?.trialOption.endOfTrialDecision === 'CTP'"
              >
                <span class="rs-price-s rs-price-promo rs-price-semi-inverted">
                  <span class="rs-euro">{{
                    "price.freeLabel" | translate
                  }}</span>
                </span>
                <span class="rs-txt-c2">
                  {{ "trial.message.beforeDate" | translate }}
                  <strong>{{
                    option?.trialOption?.deactivationDate | date: "dd/MM/yyyy"
                  }}</strong
                  >, <br />{{ "trial.message.beforePrice.optedIn" | translate }}
                  <px-currency-amount
                    [amount]="priceTrialOption"
                    [amountClass]="'rs-price-s rs-price-inverted'"
                  >
                  </px-currency-amount>
                  {{ option.trialOption | chargeFrequency: "chargeFrequency" }}
                </span>
              </ng-container>
              <ng-container
                *ngIf="option?.trialOption.endOfTrialDecision === 'NCTP'"
              >
                <span class="rs-price-s rs-price-promo rs-price-semi-inverted">
                  <span class="rs-euro">{{
                    "price.freeLabel" | translate
                  }}</span>
                </span>
                <span class="rs-txt-c2">
                  {{ "trial.message.beforeDate" | translate }}
                  <strong>{{
                    option?.trialOption?.deactivationDate | date: "dd/MM/yyyy"
                  }}</strong
                  ><br />{{ "trial.message.beforePrice.optedOut" | translate }}
                  <px-currency-amount
                    [amount]="priceTrialOption"
                    [amountClass]="'rs-price-s rs-price-inverted'"
                  >
                  </px-currency-amount>
                  {{ option.trialOption | chargeFrequency: "chargeFrequency" }}
                </span>
              </ng-container>
            </p>
            <p
              *ngIf="option?.trialOption?.endOfTrialDecision === 'NCTP'"
              class="rs-padding-bottom1"
            >
              <span class="rs-txt-warning-neg rs-font-pxB"
                ><i
                  class="icon-Status-warning rs-margin-right1"
                  aria-hidden="true"
                ></i
                >{{
                  "tv.active.options.try.and.buy.optedout" | translate
                }}</span
              >
            </p>
            <p
              *ngIf="option?.trialOption?.endOfTrialDecision === 'CTP'"
              class="rs-padding-bottom1"
            >
              <span class="rs-txt-success-neg rs-font-pxB"
                ><i
                  class="icon-Status-ok rs-margin-right1"
                  aria-hidden="true"
                ></i
                >{{ "tv.active.options.try.and.buy.optedin" | translate }}</span
              >
            </p>
            <p
              *ngIf="option?.trialOption && !isActiveTrialOption"
              class="rs-txt-c2"
            >
              <ng-container *ngIf="!option?.tryAndBuyFreeFor3Months">
                {{ "trial.message.available.join" | translate }}
              </ng-container>
              <ng-container *ngIf="option?.tryAndBuyFreeFor3Months">
                {{ "trial.message.available.join.3months" | translate }}
              </ng-container>
              {{ "trial.message.available.then" | translate }}
              <px-currency-amount
                [amount]="priceTrialOption"
                [amountClass]="'rs-price-s rs-price-inverted'"
              ></px-currency-amount>
              {{ option.trialOption | chargeFrequency: "chargeFrequency" }}
            </p>
            <div
              *ngIf="!option?.trialOption"
              class="rs-flex-row rs-flex-dir-col-small-only rs-flex-bottom-medium"
            >
              <ng-container *ngIf="!isPromoPrice; else promoPrice">
                <div class="rs-flex-columns rs-flex-shrink">
                  <div class="rs-inline-block rs-padding-bottom2 rs-txt-c2">
                    <ng-container *ngIf="isStartingFromPriceVisible">
                      {{ "option.deeplink.startingFrom" | translate }}
                    </ng-container>
                    <mprd-price
                      [option]="option"
                      [netflixBuyAndSell]="netflixBuyAndSellStatus"
                      (isIncludedOption)="isOptionIncluded($event)"
                      [showActiveStatus]="false"
                      amountClass="rs-price-m"
                      showNegativeColors="true"
                      class="rs-txt-c2"
                      data-cy="tvOptionDetailPrice"
                    ></mprd-price>
                    <a
                      *ngIf="
                        isStartingFromPriceVisible || isFreeAsteriksVisible
                      "
                      href="javascript:inception.scrollToElement('#footnotes');"
                      class="rs-txt-c2 rs-link-no-decoration"
                      aria-describedby="footnote1-label"
                      id="footnote-ref"
                      >*</a
                    >
                    <div
                      *ngIf="isOnTopCurrentPackVisible"
                      class="rs-txt-c2 text-right"
                    >
                      {{ "option.details.onTopCurrentPack" | translate }}
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #promoPrice>
                <p>
                  <span
                    class="rs-price-m rs-price-promo rs-price-semi-inverted"
                  >
                    <del
                      ><span class="show-for-sr">{{
                        "common.insteadOf" | translate
                      }}</span
                      >€{{
                        isRes
                          ? option?.customPrices?.prices[0]?.priceVat
                          : option?.customPrices?.prices[0]?.priceNoVat
                      }}</del
                    >
                    <span class="rs-nowrap"
                      ><span class="rs-euro">€</span
                      ><span class="rs-unit">{{ promoPriceNumber }}</span
                      ><span class="rs-decimal"
                        >.{{ promoPriceDecimal }}</span
                      ></span
                    >
                  </span>
                  {{ "common.perMonth" | translate }}<br />{{
                    promoPriceDuration
                  }}
                </p>
              </ng-template>
              <div class="rs-flex-columns" *ngIf="isDiscountTextVisible">
                <p
                  *ngIf="!flexPackDiscountText"
                  class="rs-txt-c2 rs-margin-top2-m medium-text-right"
                >
                  <span class="rs-txt-promo-neg">{{
                    "option.details.discountAmount" | translate
                  }}</span>
                  {{ "option.details.discountPackage" | translate }}
                </p>
                <p *ngIf="!!flexPackDiscountText" class="rs-txt-c2 medium-text">
                  <span class="rs-txt-promo-neg">{{
                    flexPackDiscountText
                  }}</span>
                </p>
              </div>
            </div>
            <div>
              <a
                *ngFor="let downloadLink of option?.downloadLinks"
                href="{{ downloadLink.webUrl }}"
                ><img
                  alt="{{ downloadLink.os }}"
                  [src]="getDownloadAppstoreImageByOs(downloadLink.os)"
                  class="rs-margin-right1"
                  target="_blank"
              /></a>
            </div>
            <div>
              <a
                *ngIf="option?.configureLink?.url"
                href="{{
                  option?.configureLink?.url[
                   language
                  ]
                }}"
                target="_blank"
                class="rs-btn rs-btn-third rs-btn-neg"
              >
                {{
                  option?.configureLink?.label[
                    language
                  ]
                }}
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <div>
              <a
                *ngIf="
                  option?.manageOptionLink &&
                  [PlcCodes.MMI, PlcCodes.MMV].indexOf(selectedProduct?.plc) !==
                    -1
                "
                href="{{
                  option?.manageOptionLink?.url[
                    language
                  ]
                }}"
                target="_blank"
                class="rs-btn rs-btn-third rs-btn-neg"
              >
                {{
                  option?.manageOptionLink?.label[
                    language
                  ]
                }}>
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <div>
              <a
                *ngIf="option?.redirectLink?.url && !isNetflixOption(option)"
                href="{{
                  option?.redirectLink?.url[
                    language
                  ]
                }}"
                target="_blank"
                class="rs-btn rs-btn-third rs-btn-neg"
              >
                {{
                  option?.redirectLink?.label[
                    language
                  ]
                }}
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <div class="rs-me"></div>
          </div>
          <div class="rs-le2 hide-for-small-only"></div>
          <div class="small-12 medium-6 large-7 column">
            <div class="rs-fe3 hide-for-small-only"></div>
            <div class="rs-mh-s13" *ngIf="hasWebdeal">
              <div class="left rs-right-medium">
                <img
                  [src]="
                    '/dam/cdn/sites/myproximus/images/MPRD/patches/webdeal/webdeal-tv-' +
                    webdealSuffix +
                    '.png'
                  "
                  alt="promo"
                />
              </div>
            </div>
            <div class="clearfix show-for-small-only"></div>
          </div>
        </div>
        <div class="rs-le"></div>
      </section>
      <section class="rs-overlapping">
        <div class="rs-fe3"></div>
        <div class="row">
          <div class="columns small-12">
            <div class="rs-panel-big rs-bg-pickx">
              <!-- AVS failure-->
              <div
                *ngIf="
                  isSmoothAccess &&
                  !isDisneyPlusProduct && !isPickXDisneyPlusProduct
                "
              >
                <p [innerHTML]="'tv.options.error' | translate"></p>
              </div>
              <div class="rs-flex-row">
                <div
                  class="rs-flex-columns small-12 medium-7 rs-flex-middle rs-order-m2"
                >
                  <div
                    *ngIf="( !isFeatureFlag ||
                      (!isDisneyPlusProduct && !isPickXDisneyPlusProduct)
) && (!isSportsFeatureFlag ||  !isSportsProduct)
                    "
                    class="rs-padding-left3-m"
                  >
                    <div class="rs-flex-row rs-flex-dir-col-small-only">
                      <div class="rs-flex-column">
                        <span
                          *ngIf="
                            showCeaseButton ||
                            option?.trialOption ||
                            isSmoothAccess
                          "
                        >
                          <p id="target">
                            <mprd-address
                              *ngIf="
                                option &&
                                selectedProduct &&
                                !isDeepLinkMultipleProductsEligible
                              "
                              [address]="selectedProduct?.installationAddress"
                              [showInOneLine]="true"
                            ></mprd-address>
                          </p>
                        </span>
                      </div>

                      <div class="rs-flex-column" data-cy="tvStatus">
                        <div class="rs-block">
                          <div
                            class="rs-status rs-status-ok"
                            *ngIf="isActiveOption()"
                          >
                            <i class="rs-status-icon" aria-hidden="true"></i
                            >{{ "common.options.active" | translate }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="rs-flex-row rs-flex-dir-col-small-only">
                      <div
                        class="rs-flex-columns rs-order-m1"
                        *ngIf="
                          (showCeaseButton || option?.trialOption) &&
                          !isSmoothAccess
                        "
                      >
                        <mprd-order-button
                          *ngIf="option?.ibStatus != OptionStatus.ERROR"
                          [(option)]="option"
                          [selectedProduct]="selectedProduct"
                          [isDeepLink]="isDeepLinkDataLoaded"
                          [deepLinkStatus]="deepLinkStatus"
                          (resultEmit)="onResult($event)"
                          [treatmentCode]="treatmentCode"
                          (webshopLoadedEvent)="onWebshopLoadedEvent($event)"
                          data-cy="optionDetailOrderButton"
                        >
                        </mprd-order-button>
                      </div>
                      <div
                        class="rs-flex-columns rs-order-m2"
                        *ngIf="!isFeatureFlag"
                      >
                        <ng-container
                          *ngIf="isDisneyOptionActivable(); else watchSection"
                        >
                          <a
                            (click)="getDisneyPlusToken()"
                            class="rs-btn rs-btn-neg rs-btn-nl-so"
                            [ngClass]="{
                              'rs-btn-waiting': isLoadingToken
                            }"
                            data-tms-event="button-click"
                            data-tms-button-zone="tv options ordering"
                            attr.data-tms-button-name="{{
                              'tv.active.options.disneyplus.button.activate'
                                | translate
                            }}"
                            target="_blank"
                            data-cy="tvDisneyPlusActivateButton"
                            >{{
                              "tv.active.options.disneyplus.button.activate"
                                | translate
                            }}
                            <i class="icon-Target-Blank rs-margin-left1"
                              ><span class="show-for-sr">{{
                                "tv.active.options.disneyplus.button.screenReader.openNewWindow"
                                  | translate
                              }}</span></i
                            >
                            <div
                              *ngIf="isLoadingToken"
                              class="rs-btn-waiting-dots"
                            ></div>
                          </a>
                        </ng-container>
                        <ng-template #watchSection>
                          <a
                            *ngIf="isDisneyOptionActive()"
                            href="{{
                              'tv.active.options.disneyplus.button.watch.link'
                                | translate
                            }}"
                            class="rs-btn rs-btn-neg rs-btn-nl-so"
                            data-tms-event="button-click"
                            data-tms-button-zone="tv options ordering"
                            attr.data-tms-button-name="{{
                              'tv.active.options.disneyplus.button.watch'
                                | translate
                            }}"
                            target="_blank"
                            data-cy="tvDisneyPlusWatchButton"
                            >{{
                              "tv.active.options.disneyplus.button.watch"
                                | translate
                            }}
                            <i class="icon-Target-Blank rs-margin-left1"
                              ><span class="show-for-sr">{{
                                "tv.active.options.disneyplus.button.screenReader.openNewWindow"
                                  | translate
                              }}</span></i
                            ></a
                          >
                        </ng-template>
                      </div>
                      <px-alert
                        [alertKey]="
                          option?.optionCodeForDescription +
                          'netflixAccountManagementAlertLevel3'
                        "
                      ></px-alert>
                      <px-alert
                        *ngIf="option || deepLinkMpcUuid"
                        [alertKey]="getAlertKey()"
                      ></px-alert>
                    </div>
                  </div>

                  <mprd-disney-plus-standard-premium
                    *ngIf="
                      isFeatureFlag &&
                      (isDisneyPlusProduct || isPickXDisneyPlusProduct)
                    "
                  ></mprd-disney-plus-standard-premium>
                  <mprd-sports-standard-premium
                    *ngIf="isSportsFeatureFlag && isSportsProduct"
                  ></mprd-sports-standard-premium>

                  <hr class="show-for-small-only" />
                </div>

                <div
                  class="rs-flex-columns small-12 medium-5 rs-pos-rel rs-col-separator-neg-M rs-order-m1"
                >
                  <div class="rs-padding-right3-m">
                    <p *ngIf="option?.description">{{ option?.description }}</p>
                    <mprd-netflix-account-management
                      [option]="option"
                      *ngIf="
                        option?.redirectLink?.url &&
                        isNetflixOption(option) &&
                        isActiveOption()
                      "
                    ></mprd-netflix-account-management>
                    <button
                      *ngIf="isDisneyPlusProduct"
                      class="rs-btn rs-btn-third rs-btn-neg"
                      aria-haspopup="true"
                      data-tms-event="button-click"
                      data-tms-button-zone="tv options ordering"
                      attr.data-tms-button-name="{{
                        'option.details.disneyplus.howToActivate.link'
                          | translate
                      }}"
                      (click)="openDisneyPlusModal()"
                      data-cy="tvDisneyPlusHowToActivate"
                    >
                      {{
                        "option.details.disneyplus.howToActivate.link"
                          | translate
                      }}<i
                        class="rs-icon-btn-third rs-margin-left1"
                        aria-hidden="true"
                      ></i>
                    </button>
                    <p
                      *ngIf="option?.disneyBSPaId"
                      data-cy="tvDisneyPlusIdentificationID"
                    >
                      {{
                        "option.details.disneyplus.identificationId" | translate
                      }}
                      {{ option?.disneyBSPaId }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="isPromotionalSectionVisible && isASorASAS">
              <div class="row">
                <div class="columns small-12">
                  <div
                    class="rs-panel-big rs-bg-pickx"
                    [innerHTML]="'tv.options.promo.htmlSection' | translate"
                  ></div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="rs-h-s1 rs-h-m6"></div>

        <div class="row">
          <div class="small-12 column">
            <div class="panel rs-no-padding rs-no-bg">
              <div class="row collapse" *ngIf="option?.image">
                <div>
                  <img class="show-for-large-up" [src]="option.image?.large" />
                  <img
                    alt="{{ optionName }}"
                    class="show-for-medium-only"
                    [src]="option.image?.medium"
                  />
                  <img
                    alt="{{ optionName }}"
                    class="show-for-small-only"
                    [src]="option.image?.small"
                  />
                </div>
              </div>
            </div>
            <span id="footnotes" aria-hidden="true" tabindex="-1"></span>
            <h2 id="footnote-label" class="show-for-sr">
              {{ "option.details.footNote.accessibility" | translate }}
            </h2>
            <small class="rs-txt-c2 rs-font-pxL rs-block">{{
              "common.options.priceMention" | translate
            }}</small>
            <small
              *ngIf="option?.customPrices?.asteriksFootnote"
              class="rs-txt-c2 rs-font-pxL rs-block"
            >
              *&nbsp;{{
                option?.customPrices?.asteriksFootnote[
                 language
                ]
              }}
              <a
                href="javascript:inception.scrollToElement('#footnote-ref');"
                class="rs-txt-c2"
                >↩</a
              >
            </small>
            <small
              *ngIf="isDeepLinkFootNoteVisible"
              class="rs-txt-c2 rs-font-pxL rs-block"
            >
              *&nbsp;{{ "option.deeplink.startingFrom.footNote" | translate }}
              <a
                href="javascript:inception.scrollToElement('#footnote-ref');"
                class="rs-txt-c2"
                >↩</a
              >
            </small>
          </div>
        </div>
        <div class="rs-le"></div>
      </section>
    </div>
  </div>
</div>
